<template>
    <div id="header_user_component"
         class="header-user-component">
        <div class="header-profile-inner">
            <router-link :to="{ path: '/profile' }">
                <div class="header-profile-fullname">
                    {{ fullname }}
                </div>
            </router-link>
        </div>
    </div>
</template>

<style lang="scss">
    @import '../../../../../assets/scss/_colors.scss';

    .header-user-component{
        display: inline-block;
        vertical-align: middle;
        margin-right: 40px;
    }

    .header-profile-inner{
        a{
            font-size: 13px;
            font-weight: bold;
            color: $base2;
        }
    }

    @media(max-width:991px){
        .header-user-component{
            margin-right: 85px;
        }
    }
</style>

<script>
    export default {
        computed: {
            fullname () {
                return this.$store.getters.userFullName
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/header/middlebar/HeaderUser.vue